import { Outlet } from 'react-router-dom';

export const Outer: React.FC = () => (
	<>
		<Outlet />
	</>
);
